import type { App } from 'vue';
import type { VueCookies } from 'vue-cookies';

import type { SitecoreDictionary } from '@/lib/dictPlugin';
import type { FischerPlugin } from '@/lib/fischerPlugin';

/**
 * The app-level service registry.
 *
 * `app.config.globalProperties` does two unrelated jobs here: it exposes values to templates,
 * and it acts as the plugins' service locator. Only the first is being removed - the second is
 * plain JS reads of the app object and stays exactly as it is.
 *
 * These declarations exist so the second job keeps its types once the template-facing
 * declarations are gone from `ComponentCustomProperties`. Without them the
 * `Record<string, any>` index signature on `globalProperties` swallows every such read
 * silently, with no compiler error to show for it.
 */
export interface FischerAppGlobals {
  $fischer: FischerPlugin;
  $dict: SitecoreDictionary;
  $cookies: VueCookies;
  isAppView: boolean;
  isUpat: boolean;
  isFite: boolean;
  isEditMode: boolean;
}

// The `unknown` hop is required: a direct cast fails with TS2352, since
// `ComponentCustomProperties & Record<string, any>` and `FischerAppGlobals` don't sufficiently overlap.
export const appGlobals = (app: App): FischerAppGlobals =>
  app.config.globalProperties as unknown as FischerAppGlobals;
